import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { CardWrapper } from 'components/Lane/Lane.css';
import { hexToRgba } from 'utils/fnColors';
import { MQ_NOT_TOUCH } from 'style/styled-components/cssMediaQueries';

export const animationType = 'ease-in-out';
export const animationDuration = '150ms';
export const animationDelay = '150ms';

export const CardChannelWrapperInner = styled.div`
    width: var(--card-width);
    height: var(--card-height);
    border-radius: 5px;
    background: ${(props) => props.theme.brandedConfig.low_contrast};
    opacity: 0.9;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    box-shadow: 0 4px 8px ${(props) => hexToRgba(props.theme.brandedConfig.black_color, 0.05)};

    ${MQ_NOT_TOUCH} {
        &:hover {
            opacity: 1;
            border: 2px solid ${(props) => props.theme.brandedConfig.white_color};
        }
    }
`;

export const ChannelBundleWrapper = styled.div`
    display: inline-block;
    vertical-align: top;
    scroll-snap-align: start;
    scroll-snap-stop: normal;
    margin-left: 8px;
    margin-right: 8px;
    height: 100%;

    &:first-child {
        margin-left: 0;
    }

    ${CardWrapper} {
        margin: 16px 0 0 0;
        display: block;

        &:first-child {
            margin-top: 0;
        }
    }
`;
